import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  guestCount: 50,
  EquipmentFilter: [
    {
      id: 1,
      value: false,
      checkingValue: "CamType",
      label: "filterEquipImage",
    },
    {
      id: 2,
      value: false,
      checkingValue: "LightType",
      label: "filterEquipLight",
    },
  ],
  FotoboxTyp: [
    {
      id: 10,
      value: false,
      checkingValue: "PhotoboothType",
      label: "filterBoothTypeStandard",
      expectedValue: "Standard",
    },
    {
      id: 11,
      value: false,
      checkingValue: "PhotoboothType",
      label: "filterBoothTypeCabine",
      expectedValue: "Kabine",
    },
    {
      id: 12,
      value: false,
      checkingValue: "PhotoboothType",
      label: "filterBoothTypeMirror",
      expectedValue: "Spiegel",
    },
    {
      id: 13,
      value: false,
      checkingValue: "PhotoboothType",
      label: "filterBoothTypeVehicle",
      expectedValue: "Fahrzeug",
    },
  ],
  DigitalFilter: [
    {
      id: 20,
      value: false,
      checkingValue: "DigitalOnlineGalerie",
      label: "filterDigitalOnlineGalery",
    },
    {
      id: 21,
      value: false,
      checkingValue: "DigitalUSB",
      label: "filterDigitalUSB",
    },
    {
      id: 22,
      value: false,
      checkingValue: "DigitalHandy",
      label: "filterDigitalHandy",
    },
  ],

  PrintFilters: [
    {
      id: 30,
      value: false,
      checkingValue: "Print",
      label: "filterPrint",
    },
    {
      id: 31,
      value: false,
      checkingValue: "SpecialPrintFlatrate",
      label: "filterPrintFlatrate",
    },
    {
      id: 32,
      value: false,
      checkingValue: "PrintTimeSeconds",
      label: "filterPrintTimeMindOkay",
    },
    {
      id: 33,
      value: false,
      checkingValue: "PaperStorageSize",
      label: "filterPrintMindOkay",
    },
  ],
  userPostalCode: "", // Neu: PLZ für "Regionaler Anbieter"
  isRegionalProvider: false,
  DeliveryFilters: [
    {
      id: 40,
      value: false,
      checkingValue: "PostDelivery",
      label: "filterShipmmentPost",
    },
    {
      id: 41,
      value: false,
      checkingValue: "SelfDelivery",
      label: "filterShipmmentSelfDelivery",
    },
  ],
  PopularFilter: [
    {
      id: 31,
      value: false,
      checkingValue: "SpecialPrintFlatrate",
      label: "filterPrintFlatrate",
    },
    {
      id: 33,
      value: false,
      checkingValue: "PaperStorageSize",
      label: "filterPrintMindOkay",
    },
  ],
  ExtrasFilter: [
    {
      id: 50,
      value: false,
      checkingValue: "Props",
      label: "filterExtrasProps",
    },
    {
      id: 51,
      value: false,
      checkingValue: "ControlLiveView",
      label: "filterExtrasLiveView",
    },
  ],
  PriceFilter: 0, // 0 = Beliebtheit, 1 = Niedrigster Preis, 2 = Höchster Preis
};

export const filterSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    toggleEquipmentFilter: (state, action) => {
      state.EquipmentFilter = state.EquipmentFilter.map((item) =>
        item.id === action.payload ? { ...item, value: !item.value } : item
      );
    },
    togglePopularFilter: (state, action) => {
      const filterId = action.payload;

      // Filter in PopularFilter toggeln
      state.PopularFilter = state.PopularFilter.map((item) =>
        item.id === filterId ? { ...item, value: !item.value } : item
      );

      // Filter in PrintFilters synchronisieren
      state.PrintFilters = state.PrintFilters.map((item) =>
        item.id === filterId ? { ...item, value: !item.value } : item
      );
    },

    toggleFotoboxTyp: (state, action) => {
      state.FotoboxTyp = state.FotoboxTyp.map((item) =>
        item.id === action.payload ? { ...item, value: !item.value } : item
      );
    },
    toggleDigitalFilter: (state, action) => {
      state.DigitalFilter = state.DigitalFilter.map((item) =>
        item.id === action.payload ? { ...item, value: !item.value } : item
      );
    },
    toggleExtrasFilter: (state, action) => {
      state.ExtrasFilter = state.ExtrasFilter.map((item) =>
        item.id === action.payload ? { ...item, value: !item.value } : item
      );
    },
    togglePrintFilter: (state, action) => {
      const filterId = action.payload;

      // Filter in PrintFilters toggeln
      state.PrintFilters = state.PrintFilters.map((item) =>
        item.id === filterId ? { ...item, value: !item.value } : item
      );

      // Filter in PopularFilter synchronisieren
      state.PopularFilter = state.PopularFilter.map((item) =>
        item.id === filterId ? { ...item, value: !item.value } : item
      );
    },

    changePriceFilter: (state, action) => {
      state.PriceFilter = action.payload;
    },
    setGuestCount: (state, action) => {
      state.guestCount = action.payload; // ✅ Gästeanzahl speichern

      // ✅ Labels für die Filter aktualisieren, aber Werte beibehalten
      state.PrintFilters = state.PrintFilters.map((filter) => {
        if (filter.checkingValue === "PaperStorageSize") {
          return {
            ...filter,
            label: `filterPrintMindOkay`,
            //label: `Drucker: mind. Okay bei ${state.guestCount} Gästen`,
          };
        }
        return filter;
      });
    },

    setPrintFilters: (state, action) => {
      state.PrintFilters = action.payload;
    },
    setDeliveryFilters: (state, action) => {
      state.DeliveryFilters = action.payload;
    },
    toggleDeliveryFilter: (state, action) => {
      state.DeliveryFilters = state.DeliveryFilters.map((item) =>
        item.checkingValue === action.payload
          ? { ...item, value: !item.value }
          : item
      );
    },
    setUserPostalCode: (state, action) => {
      state.userPostalCode = action.payload;
    },
    toggleRegionalProvider: (state) => {
      state.isRegionalProvider = !state.isRegionalProvider;
      if (!state.isRegionalProvider) {
        state.userPostalCode = ""; // ✅ PLZ zurücksetzen, wenn deaktiviert
      }
    },
  },
});

export const {
  toggleEquipmentFilter,
  togglePopularFilter,
  toggleFotoboxTyp,
  toggleDigitalFilter,
  toggleExtrasFilter,
  togglePrintFilter, // ✅ NEU: Action für PrintFilters
  changePriceFilter,
  setGuestCount,
  setDeliveryFilters,
  toggleDeliveryFilter,
  setUserPostalCode,
  toggleRegionalProvider,
  setPrintFilters,
} = filterSlice.actions;

export default filterSlice.reducer;
